export enum Division {

    CD  = 0,
    OEM = 1,
    RS  = 2,
    PMAX = 3
}

export const DivisionMetadata = {
    '0' : {
        display: 'Complete Door',
        abbreviation: 'CD',
        value: 0
    },
    '1': {
        display: 'OEM',
        abbreviation: 'OEM',
        value: 1
    },
    '2': {
        display: 'Rolling Steel',
        abbreviation: 'RS',
        value: 2
    },
    '3': {
        display: 'Performax',
        abbreviation: 'PMAX',
        value: 3
    }
}